/* eslint-disable check-file/filename-blocklist */

import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

type ReactionsContainerProps = {
	isDisabled?: boolean;
	hasReactions?: boolean;
	readOnly?: boolean;
};

// helper function for page comment reactions styles
const getPageCommentLeftMargin = (isDisabled) => {
	if (isDisabled) {
		// reactions-spacer is 5px wide
		return '0';
	} else {
		return '5px';
	}
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ReactionsContainer = styled.div<ReactionsContainerProps>(
	{
		display: 'flex',
		alignItems: 'center',
		// TODO: remove this once fixed in @atlaskit/reactions
		// reactions component shouldn't have any spacing around it, this css fix will be available soon in @atlaskit/reactions
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		"div[data-testid='render-reactions']": {
			marginTop: token('space.negative.050'),
		},
		// size & color of emoji in reaction
		// TODO: move picker icon color style in @atlaskit/reactions
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		"span[aria-label='Add reaction'] > svg[role='presentation']": {
			color: token('color.text.subtle'),
		},

		// TODO: remove this after nikita release, as margins are fixed in @atlaskit/reactions
		// spacing between reactions - only apply to reaction wrapper & reaction picker, not the buttons within reactions menu
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		"button[data-testid='render_reaction_wrapper']": {
			margin: `${token('space.050')} ${token('space.050')} 0px 0px`,
		},

		// TODO: remove this after nikita release, as margins are fixed in @atlaskit/reactions
		// spacing for reactions picker button
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		"div[data-testid='reactionPicker-testid']": {
			margin: `${token('space.050')} 0px 0px 0px`,
		},

		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		button: {
			overflow: 'hidden',

			// max width of emoji images
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
			'img[data-emoji-id]': {
				maxWidth: '30px',
			},
		},
	},
	// styling for disable state of reactions
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ isDisabled, readOnly }) =>
		(isDisabled || readOnly) && {
			'*': {
				cursor: 'not-allowed',
			},
			"span[aria-label='Add reaction'] > svg[role='presentation']": {
				color: token('color.text.subtlest'),
			},
			button: {
				cursor: 'not-allowed',
				pointerEvents: 'none',
			},
		},

	// hide the add reaction button and users dialog link for read-only
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ readOnly }) =>
		readOnly && {
			"div[data-testid='reactionPicker-testid'], button[data-testid='viewall-reacted-users-dialog']":
				{
					display: 'none',
				},
		},
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PageReactionsContainer = styled(ReactionsContainer)({
	margin: '4px 20px 0 0',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'flex-start',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PageCommentReactionsContainer = styled(
	ReactionsContainer,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
)<ReactionsContainerProps>(({ isDisabled }) => ({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	marginLeft: getPageCommentLeftMargin(isDisabled),
	marginTop: 4,
}));

// apply for inline comment on view or edit page
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const InlineCommentReactionsContainer = styled(
	ReactionsContainer,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
)<ReactionsContainerProps>(({ isDisabled }) => ({
	// TODO: review and move colors in @atlaskit/reactions
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	"span[aria-label='Add reaction'] > svg[role='presentation']": {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		color: isDisabled ? token('color.text.subtlest') : token('color.text.subtle'),
	},
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FeedReactionsContainer = styled(ReactionsContainer)<ReactionsContainerProps>({
	marginTop: 4,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const MutationErrorContainer = styled.div({
	minWidth: 240,
	marginTop: token('space.200'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const NoReactionsContainer = styled.div({
	marginLeft: token('space.050'),
});
